var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTourChatIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15,
    r: 15,
    fill: "#97144D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 12.8763H19.6667H11.3333ZM11.3333 16.043H14.6667H11.3333ZM15.5 22.3763L12.1667 19.2096H9.66667C9.22464 19.2096 8.80072 19.0428 8.48816 18.7459C8.17559 18.4489 8 18.0462 8 17.6263V11.293C8 10.873 8.17559 10.4703 8.48816 10.1734C8.80072 9.87644 9.22464 9.70963 9.66667 9.70963H21.3333C21.7754 9.70963 22.1993 9.87644 22.5118 10.1734C22.8244 10.4703 23 10.873 23 11.293V17.6263C23 18.0462 22.8244 18.4489 22.5118 18.7459C22.1993 19.0428 21.7754 19.2096 21.3333 19.2096H18.8333L15.5 22.3763Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourChatIcon);
export default __webpack_public_path__ + "static/media/tour-chat-icon.0065bf7d9fdbaf4a2686e3c275d0e1cc.svg";
export { ForwardRef as ReactComponent };